import { defineAsyncComponent } from 'vue'
export default {
  default: defineAsyncComponent(() => import("/home/wann/Development/vuenuxt/ordinator/layouts/default.vue").then(m => m.default || m))
}